import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

export const CheckAuth = (
    isUserLoggedIn: boolean,
    component: any
): ReactElement => {
    if (isUserLoggedIn) {
        return component;
    }
    return <Navigate to="/login" replace />;
};

export const CheckDashingLogOn = (
    isUserLoggedIn: boolean,
    id: string,
    component: any
): ReactElement => {
    console.log(isUserLoggedIn ," isUserLoggedIn" ,id ,"id CheckDashingLogOn")
    if (!isUserLoggedIn) {
        return component;
    }
    return <Navigate to="/dashboard" replace />;
};
